module.exports = __webpack_public_path__ + "img/logo_khff.6a3e4709.png";